import { IconButton } from '@mui/material';
import { styled, theme } from '@sb/cc-design-system';

export const ControlsRow = styled('div')`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const ControlButton = styled(IconButton)`
  padding: 4px;
  color: ${theme.palette.text.primary};
`;
